import React from 'react';
import { IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

export function doNotification(enqueueSnackbar, closeSnackbar, message, variant, autoHideDuration = 4000) {
    
    const id = enqueueSnackbar(message, {
        variant,
        autoHideDuration,
        anchorOrigin: {
            horizontal: 'right',
            vertical: 'top',
        },
        action: (key) => (
            <IconButton
                key="close"
                color="inherit"
                aria-label="Close"
                onClick={() => closeSnackbar(key)}
            >
                <CloseIcon/>
            </IconButton>
        )
    })
    return id;
}

export function closeNotification(id, closeSnackbar) {
    // if (id) {
    //     closeSnackbar(id)
    //     setTimeout(() => { id = null }, 0);
    // }
    return null;
}
